/* eslint-disable react/no-danger */
import { InferGetServerSidePropsType } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { getPageTour } from '@/services/tour';
import LoadingProgress from '@/components/common/LoadingProgress';

const DynamicComponent3WithNoSSR = dynamic(() => import('../../components/Asset'), {
  ssr: false,
});

export const getServerSideProps = async (context: { query: { slug: any }; req: any }) => {
  const { slug } = context.query;
  const data = await getPageTour({
    slug,
    origin: context.req.headers.host,
  });
  return {
    props: {
      data: JSON.stringify(data),
    },
  };
};

const IndexPage = ({ data }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const { title, description, tourImage, website, faviconUrl, charset } = JSON.parse(data);
  const router = useRouter();
  const { slug, menuItemClickedBookingPage } = router.query;
  return (
    <div>
      <Head>
        <title>{title}</title>

        <meta property="og:description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={tourImage} />
        <meta property="og:image:secure_url" content={tourImage} />
        <meta property="og:image:width" content="640" />
        <meta property="og:image:height" content="442" />
        <meta property="og:url" content={`https://${website}/asset/${slug}`} />
        <meta charSet={charset} />
        <link rel="stylesheet" href="https://static.treedis.com/fontawesome/5.15.3/css/all.min.css" />
        {faviconUrl && <link rel="icon" href={`${faviconUrl}`} />}
        <script
          dangerouslySetInnerHTML={{
            __html: `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '904257603695477');
            fbq('track', 'PageView');`,
          }}
        />
        <noscript>
          <img height="1" width="1" style={{ display: 'none' }} src="https://www.facebook.com/tr?id=904257603695477&ev=PageView&noscript=1" alt="" />
        </noscript>
      </Head>
      <DynamicComponent3WithNoSSR
        matterId={slug}
        menuItemClickedBookingPage={menuItemClickedBookingPage}
        reactAws={process.env.REACT_APP_AWS}
        googleKey={process.env.REACT_APP_GOOGLE_KEY}
      />
    </div>
  );
};

export default IndexPage;
